import Toast from "components/toast";
import api from "services/axiosInstance";
import { IMusicData } from "types/musicData";
import { ISongsContainerService } from "types/uploadTrackType";

export const CreateTrackContainerService = async (
  data: IMusicData,
  coverArtId: string
) => {
  let countries: string[] = [];

  if (data.schedule.countries) {
    //convert from {country , continent} to country
    for (let i = 0; i < data?.schedule?.countries?.length; i++) {
      countries.push(data.schedule.countries[i].country);
    }
  }

  const ConvertToIsoString = (date: string) => {
    return new Date(date).toISOString();
  };
  const body: ISongsContainerService = {
    title: data.releaseTitle,
    type: data.releaseType.toLocaleUpperCase(),
    releaseLanguage: data.releaseLanguage,
    primaryGenre: data.primaryGenre,
    secondaryGenres: [data.secondaryGenre],
    recordingYear: 2024,
    totalTracks: data.trackList.length,
    label: data.recordLabel,
    coverArtId: coverArtId,
    originalReleaseDate: ConvertToIsoString(
      `${data.schedule.originalReleaseDate}`
    ),
    isExplicit: false,
    isPreOrder: false,
    primaryArtistId: data.primaryArtist.id,
    proposedReleaseDate: ConvertToIsoString(
      `${data.schedule.proposedReleaseDate}`
    ),
    releaseTime: `${data.schedule.releaseTime}`,
    price: Number(data.schedule.trackPrice),
    targetStores: data.stores,
    targetCountries: countries
  };

  if (data.schedule.preorderDate) {
    body.isPreOrder = true;
    body.preOrderDate = ConvertToIsoString(`${data.schedule.preorderDate}`);
  }
  let containerId = "";
  try {
    const { data } = await api.post("/songs/containers", body);

    containerId = data.data.id;

    return containerId;
  } catch (error) {
    throw error;
  } finally {
    return containerId;
  }
};
